import React, { useState, useContext, useEffect, Fragment } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";

import * as EmailValidator from "email-validator";
import { AuthContext } from "../../context/AuthContext";
import { AlertContext } from "../../context/AlertContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { getBrand, createBrandTheme } from "../../theme/brand";
import Spinner from "../layout/Spinner";
import Barra from "../layout/Barra";

export default function Account() {
  const { state, registrarUsuario, usuarioAutenticado } =
    useContext(AuthContext);
  const { mensajeAlerta } = useContext(AlertContext);
  const { statusAcceso, configuracion, obtenerAcceso } =
    useContext(ConfiguracionContext);

  const [usuario, guardarUsuario] = useState({
    nombre: "",
    apellido: "",
    email: "",
    password: "",
    password2: "",
  });
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();
  const theme = createBrandTheme(getBrand(configuracion));

  const { nombre, apellido, email, password, password2 } = usuario;

  useEffect(() => {
    usuarioAutenticado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Account" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (statusAcceso === 400) {
      mensajeAlerta(
        "Accesos",
        "No tiene permiso para acceder a esta pantalla !.",
        "error",
      );
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusAcceso]);

  const set = (patch) => guardarUsuario({ ...usuario, ...patch });

  const crearCuenta = (e) => {
    e.preventDefault();

    if (nombre.trim() === "") {
      mensajeAlerta("Registro de Usuarios", "El nombre es necesario !.", "error");
      return;
    }
    if (apellido.trim() === "") {
      mensajeAlerta(
        "Registro de Usuarios",
        "El apellido es necesario !.",
        "error",
      );
      return;
    }
    if (email.trim() === "") {
      mensajeAlerta("Registro de Usuarios", "El email es necesario !.", "error");
      return;
    }
    if (!EmailValidator.validate(email)) {
      mensajeAlerta("Registro de Usuarios", "El email es incorrecto !.", "error");
      return;
    }
    if (password.trim() === "") {
      mensajeAlerta(
        "Registro de Usuarios",
        "El password es incorrecto !.",
        "error",
      );
      return;
    }
    if (password.length < 6) {
      mensajeAlerta(
        "Registro de Usuarios",
        "El password debe tener al menos 6 caracteres !.",
        "error",
      );
      return;
    }
    if (password2 !== password) {
      mensajeAlerta(
        "Registro de Usuarios",
        "Los password son diferentes !.",
        "error",
      );
      return;
    }

    registrarUsuario({ nombre, apellido, email, password });
    setRedirect(true);
  };

  return (
    <Fragment>
      <Barra />

      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}

      {statusAcceso === 200 ? (
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="sm" sx={{ py: 4 }}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, sm: 4 },
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Avatar sx={{ bgcolor: "primary.main", mb: 1 }}>
                  <PersonAddAlt1OutlinedIcon />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Crear Cuenta
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="nombre"
                    required
                    fullWidth
                    id="nombre"
                    label="Nombre"
                    autoFocus
                    value={nombre}
                    onChange={(e) => set({ nombre: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    id="apellido"
                    label="Apellido"
                    name="apellido"
                    value={apellido}
                    onChange={(e) => set({ apellido: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    id="email"
                    label="Dirección de Email"
                    name="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => set({ email: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => set({ password: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    name="password2"
                    label="Repetir password"
                    type="password"
                    id="password2"
                    value={password2}
                    onChange={(e) => set({ password2: e.target.value })}
                  />
                </Grid>
              </Grid>

              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3 }}
                onClick={crearCuenta}
              >
                Crear Cuenta
              </Button>
            </Paper>
          </Container>
          {redirect ? <Navigate to="/" /> : null}
        </ThemeProvider>
      ) : null}
    </Fragment>
  );
}
